import api from '@/api/api';
import { iniciarRequisicao, logout } from "@/helpers";
import { STATUS_HTTP } from "@/api/statusHTTP";

export const iniciarDadosGrafico = async (params) => {
  let url = '/indicadores/status-produtos';

  const { data, status } = await api.post(url, params, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data;
}

export const buscarDadosDetalhesDialog = async (params) => {
  let url = '/indicadores/status-produtos/buscar-dados-detalhes-dialog';

  const { data, status } = await api.post(url, params, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.detalhes;
}
